//----------处理页面url后面参数相关的功能---------------------

export default {
	//@param {name} [str] 获取url后面特定名称的值;
	/*例子：
	如 https://jr.meizu.com?id=4545
	dealPar.getPar('id') // 4545
	*/
	getPar: function(name) {
		var arry = window.location.search.substr(1).split('&'),
			res = undefined;
		arry.forEach(function(v) {
			var a = v.split('=');
			if (a[0] == name) {
				res = a[1];
				return false;
			}
		});
		return (res == undefined ? undefined : decodeURIComponent(res));
	},
	//@param {obj} [object] 将obj转为key=val&key1=val2的字符串值（val是经过encodeURIComponent）
	encodeURIComponentObj: function(obj) {
		// 非对象类型
		if (Object.prototype.toString.call(obj) != "[object Object]") {
			console.error('组件dealPar encodeURIComponentObj: ' + obj + ' is not object');
			return null;
		}
		var res = '';
		for (var key in obj) {
			var par = obj[key];
			if (typeof par == 'object') {
				par = JSON.stringify(par);
			}
			res += key + '=' + encodeURIComponent(par) + '&';
		}
		var last = res.lastIndexOf('&');
		return res.slice(0, last);
	},
	// 把url后面的参数转为 obj
	unSerializeUrl: function() {
		var arr = decodeURIComponent(window.location.search.substr(1)).split(/&|=/),
			map = {};
		for (var i = 0, ilen = arr.length; i < ilen - 1; i += 2) {
			map[arr[i]] = arr[i + 1];
		}
		return map;
	}
}


// WEBPACK FOOTER //
// ./src/dealPar.js